/* Bandeau cookies de Shopify — croix de fermeture (16/09/2026).
   Le bandeau ne propose que « Accepter » et « Refuser », et il recouvre le bas de l'écran.
   La croix vaut refus des cookies non essentiels : on l'enregistre par l'API de
   confidentialité quand elle est disponible, puis on masque le bandeau pour la visite. */
(function () {
  var KEY = 'hg_cookies_fermees';
  var SELECTEUR = '#shopify-pc__banner';

  function fermer(banner) {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      if (p && p.setTrackingConsent) {
        p.setTrackingConsent({ analytics: false, marketing: false, preferences: false, sale_of_data: false }, function () {});
      }
    } catch (e) {}
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    banner.style.display = 'none';
  }

  function ajouterCroix() {
    var banner = document.querySelector(SELECTEUR);
    if (!banner) return false;
    var dejaFerme = false;
    try { dejaFerme = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    if (dejaFerme) { banner.style.display = 'none'; return true; }
    if (banner.querySelector('.hg-cookie-close')) return true;
    if (window.getComputedStyle(banner).position === 'static') banner.style.position = 'relative';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hg-cookie-close';
    btn.setAttribute('aria-label', 'Fermer et refuser les cookies non essentiels');
    btn.title = 'Fermer (refuser les cookies non essentiels)';
    btn.textContent = '✕';
    btn.style.cssText = 'position:absolute;top:8px;right:10px;width:34px;height:34px;padding:0;border:0;' +
      'border-radius:50%;background:rgba(3,27,52,.08);color:#031b34;font-size:16px;font-weight:700;' +
      'line-height:1;cursor:pointer;z-index:5';
    btn.addEventListener('click', function (e) { e.preventDefault(); fermer(banner); });
    banner.appendChild(btn);
    return true;
  }

  function init() {
    ajouterCroix();
    if (window.MutationObserver) {
      new MutationObserver(function () { ajouterCroix(); }).observe(document.body, { childList: true });
    }
    var essais = 0;
    var timer = setInterval(function () {
      if (ajouterCroix() || ++essais > 20) clearInterval(timer);
    }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
